import "./Footer.scss"

function Footer (){

    return (
        <div className="footer-main">
            <p className="footer-main__text">©InStock Inc. All Right Reserved</p>
        </div>
    )
}
export default Footer